import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  // private _storage: Storage | null = null;

  constructor() { }

  public async init(): Promise<void> {
    // No initialization needed for Capacitor Preferences
    return;
  }

  public async set(key: string, value: any): Promise<void> {
    await Preferences.set({
      key,
      value: JSON.stringify(value)
    });
  }

  public async get(key: string): Promise<any> {
    const { value } = await Preferences.get({ key });
    return value ? JSON.parse(value) : null;
  }

  public async remove(key: string): Promise<void> {
    await Preferences.remove({ key });
  }
}
